// const baseURL = "https://staging.alvibeauty.com/v1";
const baseURL = "https://api.alvibeauty.com/v1";
const rawURL = "https://api.alvibeauty.com";

export { baseURL, rawURL };
